import React, {useState} from 'react';
import Select from 'react-select';
import { ROLE_SENIOR_MASTER } from '../../../Constants/ConstantsOptics';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '15px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    width: '230px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};


const CableContainerSummit = ({toggleVisibilityCable, isVisibleCable, cableData,
      handleCableSelectChange, cableTypeData, handleLineStyleSelectChange,
      contractorData, selectedContractor, handleChangeContractor, 
        commentCable, commentTextAreaRefCable, handleCommentChangeCable,
      isLineDrawing, handleStartDrawing, handleStopDrawing, handleCableSave, handleChangeCableType,selectedTypeCable,
      handleChangeCableSelect, selectedCable, rankCableData, handleChangeRankCable,
      selectedRankCable, selectedGroup, setSelectedGroup, isSubway, setIsSubway, role, setSelectedContractor }) => {


   const [inputValue, setInputValue] = useState("");
   const [showUnknown, setShowUnknown] = useState(false);


   const groupLabels = {
      2: "Подземка",
      3: "Воздушка",
      4: "Неизвестно",
      5: "Без маркировки"
    };

    const options = cableData.map(cable => ({
      value: `${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`,
      label: cable.name,
      group: groupLabels[cable.cableGroupId] || "Другое"
    }));

    // если выбрана Подземка + чекбокс подземка2 включен → грузим Без маркировки
    const effectiveGroup =
      selectedGroup === "Подземка" && isSubway ? "Без маркировки" : selectedGroup;

    const groupedOptions = [
      {
        label: effectiveGroup,
        options: options.filter(option => option.group === effectiveGroup)
      }
    ];

   
  
      //    // Преобразуем данные кабелей в формат для react-select
      //    const options = cableData.map(cable => ({
      //     value: `${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`,
      //     label: cable.name,
      //     group: cable.cableGroupId === 3 ? "Воздушка" : cable.cableGroupId === 4 ? "Неизвестно" : "Подземка",
      // }));
      
      // // Фильтруем опции в зависимости от состояния чекбокса
      // const groupedOptions = showUnknown
      // ? [
      //     { label: "Неизвестно", options: options.filter(option => option.group === "Неизвестно") }
      //   ]
      // : [
      //     { label: "Воздушка", options: options.filter(option => option.group === "Воздушка") },
      //     { label: "Подземка", options: options.filter(option => option.group === "Подземка") },
      //   ];
  
    
        
  return (
    <React.Fragment>
      <button onClick={toggleVisibilityCable} className={isVisibleCable ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'}>
        {isVisibleCable ? 'Кабель: скрыть' : 'Кабель: показать'}
      </button>
      {isVisibleCable && (                  
        <div className='divСommunicationsDrawer'>
          <img src='./cable.png' width='30' height='30' style={{marginRight: "5px"}}/>
          <label className='textTitleDrawer'>Оптоволокно</label>
          
          <hr className="horizontalLineDrawer" style={{marginTop: "5px", marginBottom: "10px"}}/>
          <div className="selectContainer">
            <div>

         <div style={{ display: "flex", gap: "20px",marginTop: '5px', marginBottom: "5px", color: "#a3a3a3", fontSize: "12px" }}>
             <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
               <input
                 type="checkbox"
                 checked={selectedGroup === "Воздушка"}
                 onChange={() => setSelectedGroup("Воздушка")}
               />
               воздушка
             </label>
            
             <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
               <input
                 type="checkbox"
                 checked={selectedGroup === "Неизвестно"}
                 onChange={() => setSelectedGroup("Неизвестно")}
               />
               неизвестный кабель
             </label>
         
              {role.role !== ROLE_SENIOR_MASTER && (
               <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                 <input
                   type="checkbox"
                   checked={selectedGroup === "Подземка"}
                     onChange={() => {
                       setSelectedGroup("Подземка");
                       setIsSubway(false); // сбрасываем подземка2 при переключении
                     }}  
                 />
                 подземка
               </label>
           )}
         
           
           </div>
            <hr className="horizontalLineDrawer" style={{marginTop: "5px", marginBottom: "10px", background: "white"}}/>
         
           {(selectedGroup === "Подземка") && (
             <div style={{maxWidth: '150px'}}>
               <label style={{ display: "flex", gap: "5px",color: "#a3a3a3", fontSize: "14px", marginBottom: '5px',textShadow: "1px 1px 2px #444444"}}>
                 <input
                   type="checkbox"
                   checked={isSubway}
                   onChange={e => setIsSubway(e.target.checked)}
                 />
                 без маркировки
               </label>
               </div>
             )}

            <Select
                className="selectSearchDrawer"
                options={groupedOptions}
                inputValue={inputValue}
                styles={customStyles}
                value={options.find(option => option.value === selectedCable) || null}
                onInputChange={value => setInputValue(value)}
                onChange={selectedOption => {              
                    handleCableSelectChange(selectedOption);
                    handleChangeCableSelect(selectedOption);
                }}
                placeholder="Выберите кабель"
                isClearable
            />
        </div>

          {/* <Select
                  className="selectSearchDrawer"
                  options={groupedOptions}
                  inputValue={inputValue}
                  styles={customStyles}
                  value={options.find(option => option.value === selectedCable) || null} // Если нет совпадения, передаем null
                  onInputChange={value => setInputValue(value)} // Обновляем состояние фильтра
                  onChange={selectedOption => {              
                      handleCableSelectChange(selectedOption);
                      handleChangeCableSelect(selectedOption);
                  
                  }}
                  placeholder="Выберите кабель"
                  isClearable
                /> */}

          {/* <select 
                    className="selectStyleDrawer" 
                    value={selectedCable}
                    onChange={(event) => {
                      handleCableSelectChange(event);
                      handleChangeCableSelect(event);
                    }}
                  >
                    <option value="">Выберите кабель</option> */}
                    
                    {/* Группа Воздушка */}
                    {/* <optgroup label="Воздушка">
                      {cableData
                        .filter(cable => cable.cableTypeId === 3)
                        .map(cable => (
                          <option 
                            key={cable.id} 
                            value={`${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`}
                          >
                            {cable.name}
                          </option>
                        ))}
                    </optgroup> */}
                    
                    {/* Группа Подземка */}
                    {/* <optgroup label="Подземка">
                      {cableData
                        .filter(cable => cable.cableTypeId === 2)
                        .map(cable => (
                          <option 
                            key={cable.id} 
                            value={`${cable.id},${cable.color},${cable.width},${cable.name},${cable.fiberQuantity}`}
                          >
                            {cable.name}
                          </option>
                        ))}
                    </optgroup>
                  </select>          */}
                                    
          </div>
          <div>
             <select
                    className="selectStyleDrawer"
                    value={selectedTypeCable || ""}
                    style={{ marginTop: '10px' }}
                    onChange={(event) => {
                      handleLineStyleSelectChange(event);
                      handleChangeCableType(event);
                    }}
                  >
                    <option value="">Тип прокладки</option>
                    {cableTypeData
                      .filter(cableType =>
                        selectedGroup === "Подземка"
                          ? cableType.id === 2
                          : cableType.id !== 2
                      )
                      .map(cableType => (
                        <option
                          key={cableType.id}
                          value={`${cableType.id},${cableType.type},${cableType.kind}`}
                        >
                          {cableType.type}
                        </option>
                      ))}
                  </select>
          {/* <select className="selectStyleDrawer" value={selectedTypeCable || ""} style={{marginTop: '10px'}}    
                onChange={(event) => {
                  handleLineStyleSelectChange(event);
                  handleChangeCableType(event);
                }} >
              <option value="">Тип прокладки</option>
              {cableTypeData.map(cableType => (
                <option key={cableType.id} value={`${cableType.id},${cableType.type},${cableType.kind}`}>{cableType.type}</option>
              ))}
            </select>   */}

          {selectedGroup === "Подземка" && (
            <select className="selectStyleDrawer" style={{marginTop: "10px"}} value={selectedContractor || ""}
             onChange={e => setSelectedContractor(Number(e.target.value))} >           
              <option value="">Подрядчик</option>
              {contractorData.map(contractor => (
                <option key={contractor.id} value={`${contractor.id}`}>{contractor.name}</option>
              ))}
            </select>  
          )} 


            <select className="selectStyleDrawer" style={{marginTop: "10px"}} value={selectedRankCable || ""} onChange={handleChangeRankCable} >
                   <option value="">Отоносится к узлам</option>
                   {rankCableData
                    .filter(rankCable => [1, 2, 4, 10, 11].includes(rankCable.id))
                    .map(rankCable => (
                      <option key={rankCable.id} value={`${rankCable.id}`}>
                        {rankCable.name}
                      </option>
                    ))}
             </select>

            <hr className="horizontalLineDrawer" style={{marginTop: "10px"}}/>
                          
            <textarea
              className='areaDescriptionDrawer'
              placeholder="Комментарий"
              rows={3}
              cols={44}
              value={commentCable}
              ref={commentTextAreaRefCable}
              onChange={handleCommentChangeCable}
            />     
          </div>
          <div>
            {!isLineDrawing && (
              <button onClick={handleStartDrawing} className='buttonIsDrawingDrawer'>Начать</button>
            )}
            {isLineDrawing && (
              <button onClick={handleStopDrawing} className='buttonIsDrawingDrawer2'>Завершить</button>
            )}
            <button onClick={handleCableSave} className='buttonSaveDrawer'>Сохранить</button>             
          </div>
        </div>  
      )}
    </React.Fragment>
  );
};

export default CableContainerSummit;